import { TABLE_TYPES } from "./../components/tableComponent/tableComponentService.js";
import { EVENT_ACTIONS } from "./gtag.js";
import { TOP_SCORES_TABS } from "./../components/playerStatsComponent/playerStatsService.js";
const TAB_EVENTS = {
  fixture: {
    Table: EVENT_ACTIONS.TAB_SELECTION_MATCH_TABLE,
    Lineups: EVENT_ACTIONS.TAB_SELECTION_MATCH_LINEUPS,
    Summary: EVENT_ACTIONS.TAB_SELECTION_MATCH_SUMMARY,
    Stats: EVENT_ACTIONS.TAB_SELECTION_MATCH_STATS,
    H2H: EVENT_ACTIONS.TAB_SELECTION_MATCH_H2H,
    Videos: EVENT_ACTIONS.TAB_SELECTION_MATCH_VIDEOS
  },
  league: {
    Table: EVENT_ACTIONS.TAB_SELECTION_LEAGUE_TABLE,
    Fixtures: EVENT_ACTIONS.TAB_SELECTION_LEAGUE_FIXTURES,
    Results: EVENT_ACTIONS.TAB_SELECTION_LEAGUE_RESULTS,
    PlayerStats: EVENT_ACTIONS.TAB_SELECTION_LEAGUE_PLAYER_STATS,
    Videos: EVENT_ACTIONS.TAB_SELECTION_LEAGUE_VIDEOS
  },
  team: {
    Table: EVENT_ACTIONS.TAB_SELECTION_TEAM_TABLE,
    Fixtures: EVENT_ACTIONS.TAB_SELECTION_TEAM_FIXTURES,
    Results: EVENT_ACTIONS.TAB_SELECTION_TEAM_RESULTS,
    PlayerStats: EVENT_ACTIONS.TAB_SELECTION_TEAM_PLAYER_STATS,
    Videos: EVENT_ACTIONS.TAB_SELECTION_TEAM_VIDEOS,
    Squads: EVENT_ACTIONS.TAB_SELECTION_TEAM_SQUADS
  }
};
const TABLE_FILTER_EVENTS = {
  fixture: {
    [TABLE_TYPES.ALL.value]: EVENT_ACTIONS.FILTER_TABLE_MATCH_ALL,
    [TABLE_TYPES.HOME.value]: EVENT_ACTIONS.FILTER_TABLE_MATCH_HOME,
    [TABLE_TYPES.AWAY.value]: EVENT_ACTIONS.FILTER_TABLE_MATCH_AWAY
  },
  league: {
    [TABLE_TYPES.ALL.value]: EVENT_ACTIONS.FILTER_TABLE_LEAGUE_ALL,
    [TABLE_TYPES.HOME.value]: EVENT_ACTIONS.FILTER_TABLE_LEAGUE_HOME,
    [TABLE_TYPES.AWAY.value]: EVENT_ACTIONS.FILTER_TABLE_LEAGUE_AWAY
  },
  team: {
    [TABLE_TYPES.ALL.value]: EVENT_ACTIONS.FILTER_TABLE_TEAM_ALL,
    [TABLE_TYPES.HOME.value]: EVENT_ACTIONS.FILTER_TABLE_TEAM_HOME,
    [TABLE_TYPES.AWAY.value]: EVENT_ACTIONS.FILTER_TABLE_TEAM_AWAY
  }
};
const PLAYER_STATS_FILTER_EVENTS = {
  league: {
    [TOP_SCORES_TABS.ASSIST_TOPSCORER.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_LEAGUE_ASSISTS,
    [TOP_SCORES_TABS.GOAL_TOPSCORER.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_LEAGUE_GOALS,
    [TOP_SCORES_TABS.REDCARDS.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_LEAGUE_RED,
    [TOP_SCORES_TABS.YELLOWCARDS.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_LEAGUE_YELLOW,
    [TOP_SCORES_TABS.ALL.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_LEAGUE_ALL
  },
  team: {
    [TOP_SCORES_TABS.ASSIST_TOPSCORER.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_TEAM_ASSISTS,
    [TOP_SCORES_TABS.GOAL_TOPSCORER.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_TEAM_GOALS,
    [TOP_SCORES_TABS.REDCARDS.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_TEAM_RED,
    [TOP_SCORES_TABS.YELLOWCARDS.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_TEAM_YELLOW,
    [TOP_SCORES_TABS.ALL.value]: EVENT_ACTIONS.FILTER_PLAYER_STATS_TEAM_ALL
  }
};
const NAVIGATION_EVENTS = {
  matches: EVENT_ACTIONS.FOOTER_MATCHES,
  goals: EVENT_ACTIONS.FOOTER_GOALS,
  news: EVENT_ACTIONS.FOOT_NEWS
};
export {
  NAVIGATION_EVENTS,
  PLAYER_STATS_FILTER_EVENTS,
  TABLE_FILTER_EVENTS,
  TAB_EVENTS
};
